import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ImportAgreementsResponse } from "@/types";

async function importAgreements(
  request: FormData
): Promise<ImportAgreementsResponse> {
  const response = await httpRequest.post<ImportAgreementsResponse>(
    "/covenants/import",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useImportAgreementsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importAgreements,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agreements"] });
    },
  });
}